import {
  Button,
  Typography,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  ListItemSecondaryAction,
  TextField,
  Collapse,
  FormGroup,
  FormControlLabel,
} from '@material-ui/core';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import React, { useState, useEffect } from 'react';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import { useSnackBars } from '../../../alerts/SnackBarProvider';
import { COLORS } from '../../util/Colors';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';

const RolesArray = props => {
  const { formState, setFormState, formIndex } = props;
  const [open, setOpen] = useState(false);
  const [roles, setRoles] = useState([]);
  const { authStore } = useRootStore();

  const handleClick = () => {
    setOpen(!open);
  };

  const handleChange = id => {
    const formPayload = [...formState];
    const rolesPayload = [...roles];
    const { selected } = rolesPayload[id];
    rolesPayload[id].selected = !selected;

    formPayload[formIndex].roles = rolesPayload
      .filter(role => role.selected)
      .map(role => role.OrgRoleId);

    setFormState(formPayload);
  };

  const getRoles = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/roles`,
      );
      const filteredRoles = data.filter(role => !role.IsOwner);
      filteredRoles.map(role => {
        role.selected = false;
        return role;
      });
      setRoles(filteredRoles);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (roles.length === 0) getRoles();
  }, [roles]);

  return (
    <ListItem
      style={{
        alignItems: 'flex-start',
        flexFlow: 'column nowrap',
        marginLeft: '8px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ListItemIcon onClick={handleClick}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemIcon>
        <ListItemText primary="Select Roles" />
      </div>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <FormGroup
          style={{
            display: 'flex',
            flexFlow: 'row wrap',
            marginLeft: '30px',
          }}
        >
          {roles.map((role, index) => (
            <FormControlLabel
              key={role.Name}
              control={
                <Checkbox
                  size="small"
                  name={role.Name}
                  checked={role.selected}
                  onChange={() => handleChange(index)}
                />
              }
              label={role.Name}
            />
          ))}
        </FormGroup>
      </Collapse>
    </ListItem>
  );
};

function FormDialog(props) {
  const [open, setOpen] = useState(false);
  const [formState, setFormState] = useState([]);
  const { extUsers, sentInvites } = props;
  const { orgStore, authStore, dataStore } = useRootStore();
  const [loading, setLoading] = useState(true);

  const handleAlert = useSnackBars();

  const contacts = dataStore.contactArray;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (extUsers) {
      const initVal = [];
      extUsers.map(user => {
        const contactName = `${user.FirstName} ${user.LastName}`;
        let alreadyInvited = false;
        if (sentInvites) {
          alreadyInvited = !!sentInvites.find(
            i => i.Email === user.EmailAddress,
          );
        }
        const contactExists = !!contacts.find(c => c.Name === contactName);

        return initVal.push({
          ...user,
          contactName,
          selected: !alreadyInvited,
          contactExists,
          alreadyInvited,
          roles: [],
        });
      });
      setFormState(initVal);
      setLoading(false);
    }
  }, [extUsers]);

  const handleClick = id => {
    const payload = [...formState];
    const { selected } = payload[id];
    payload[id].selected = !selected;

    setFormState(payload);
  };

  const handleCreateContact = async name => {
    try {
      const { data } = await authStore.request.post(
        `${process.env.REACT_APP_API}/api/contact`,
        {
          Name: name,
          IsAgent: 1,
        },
      );
      dataStore.retrieveContacts();
      return data;
    } catch (e) {
      console.error(e);
    }
  };
  const handleCreateInvite = async user => {
    const { EmailAddress, contactName, contactExists, roles } = user;
    const { settings } = orgStore;
    const { name: inviterName, email: inviterEmail } = authStore;

    if (contactExists) {
      const cId = contacts.find(contact => contact.Name === contactName)
        .ContactId;
      try {
        await authStore.request.post(
          `${process.env.REACT_APP_API}/api/invitation`,
          {
            email: EmailAddress,
            roles,
            contactId: cId,
            name: contactName,
            orgName: settings.Name,
            emailTemplateData: {
              inviter_name: inviterName,
              inviter_email: inviterEmail,
            },
          },
        );
      } catch (e) {
        console.log(e);
      }
    } else {
      Promise.resolve(handleCreateContact(contactName)).then(async response => {
        try {
          await authStore.request.post(
            `${process.env.REACT_APP_API}/api/invitation`,
            { email: EmailAddress, roles: [OrgRoleId], contactId: response.id },
          );
        } catch (e) {
          console.error(e);
        }
      });
    }
  };

  const handleContactChange = id => e => {
    const newState = [...formState];
    newState[id].contactName = e.target.value;
    setFormState(newState);
  };

  const handleSubmit = () => {
    Promise.resolve(
      formState.forEach(user => user.selected && handleCreateInvite(user)),
    ).then(() => {
      handleAlert('Your Invitations Have Been Sent', COLORS.green);
      setOpen(false);
    });
  };

  const validateForm =
    formState.every(user => !user.selected) ||
    formState.some(u => contacts.some(c => c.name === u.contactName)) ||
    formState.some(u => u.contactName.length === 0) ||
    formState.some(u => u.selected && u.roles.length === 0);

  return (
    <div>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        Select Recipients
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Select Recipients</DialogTitle>

        <DialogContent>
          {loading ? (
            <Spinner />
          ) : (
            <div>
              <DialogContentText>
                Select who you would like to invite to join your Deal Map
                organization. Users invited this way will automatically be
                assigned the role of an Agent, you may change this at any time.
              </DialogContentText>
              {formState.some(
                user => user.contactExists && !user.alreadyInvited,
              ) && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <PriorityHighIcon
                    fontSize="small"
                    style={{ color: COLORS.orange }}
                  />
                  <p
                    style={{
                      color: '#546e7a',
                      fontSize: '14px',
                      marginLeft: '8px',
                    }}
                  >
                    It appears some of these users share a name with an existing
                    contact. If you do not wish to associate the two please
                    review the list and make the neccessary changes, otherwise
                    you may proceed.
                  </p>
                </div>
              )}

              <List>
                {extUsers &&
                  formState.map(
                    (
                      {
                        EmailAddress,
                        FirstName,
                        LastName,
                        selected,
                        contactExists,
                        alreadyInvited,
                        contactName,
                      },
                      index,
                    ) => {
                      return (
                        <div key={EmailAddress}>
                          <ListItem>
                            <ListItemIcon>
                              <Checkbox
                                disabled={alreadyInvited}
                                checked={selected}
                                onClick={() => handleClick(index)}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={`${FirstName} ${LastName}`}
                              style={{ color: '#BDBDBD' }}
                              primaryTypographyProps={{
                                color: alreadyInvited ? 'inherit' : 'initial',
                              }}
                              secondary={EmailAddress}
                              secondaryTypographyProps={{
                                color: alreadyInvited ? 'inherit' : 'initial',
                              }}
                            />
                            {alreadyInvited && (
                              <span
                                style={{ color: '#BDBDBD', fontSize: '14px' }}
                              >
                                User already Invited
                              </span>
                            )}
                            {contactExists && !alreadyInvited && (
                              <ListItemSecondaryAction>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                  }}
                                >
                                  <TextField
                                    label="Contact Name"
                                    error={contactName.length === 0}
                                    name="contactName"
                                    value={contactName}
                                    onChange={handleContactChange(index)}
                                  />
                                  {contacts.some(
                                    c =>
                                      c.Name === contactName ||
                                      contactName.length === 0,
                                  ) ? (
                                    <PriorityHighIcon
                                      fontSize="default"
                                      style={{ color: COLORS.orange }}
                                    />
                                  ) : (
                                    <CheckIcon
                                      fontSize="default"
                                      style={{ color: COLORS.green }}
                                    />
                                  )}
                                </div>
                              </ListItemSecondaryAction>
                            )}
                          </ListItem>
                          {!alreadyInvited && (
                            <RolesArray
                              formState={formState}
                              setFormState={setFormState}
                              formIndex={index}
                            />
                          )}
                        </div>
                      );
                    },
                  )}
              </List>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            disabled={validateForm}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const InviteExtUsers = () => {
  const [extUsers, setExtUsers] = useState(null);
  const [filteredUsrs, setFilteredUsrs] = useState(null);
  const { orgStore, authStore } = useRootStore();
  const [teamSize, setTeamSize] = useState(0);
  const [sentInvites, setSentInvites] = useState(null);

  return (
    <Observer
      render={() => {
        const { orgUserArray } = orgStore;

        const userArrayComp = () => {
          if (extUsers) {
            const orgUsrEmails = orgUserArray.map(x => x.Email);

            const filterUsers = extUsers.filter(
              user => !orgUsrEmails.includes(user.EmailAddress),
            );

            setTeamSize(filterUsers.length);
            setFilteredUsrs(filterUsers);
          }
        };

        const fetchInvites = async () => {
          try {
            const { data: returnedSentInvites } = await authStore.request.get(
              `${process.env.REACT_APP_API}/api/organization/invitations`,
            );
            setSentInvites(returnedSentInvites);
          } catch (e) {
            console.error(e);
          }
        };

        const getExtUsers = async () => {
          try {
            const { data } = await authStore.request.get(
              `${process.env.REACT_APP_API}/api/ext-sys-users`,
            );
            setExtUsers(data);
          } catch (e) {
            console.log('something wrong here: ', e);
          }
        };

        useEffect(() => {
          Promise.all([getExtUsers(), fetchInvites()]);
        }, []);

        useEffect(() => {
          userArrayComp();
        }, [extUsers]);

        return (
          <div style={{ height: 'inherit' }}>
            <Typography variant="h4">Invite External Users</Typography>
            <div
              style={{
                textAlign: 'left',
                fontSize: '14px',
                height: 'inherit',
                display: 'flex',
                flexFlow: 'column nowrap',
              }}
            >
              <div>
                <p>
                  If you have integrated with an accounting system and want to
                  bring your team over to Deal Map click below to proceed.
                </p>

                <p>
                  You currently have{' '}
                  {teamSize === 1
                    ? `${teamSize} member`
                    : `${teamSize} members`}{' '}
                  you can invite.
                </p>
              </div>
              <FormDialog extUsers={filteredUsrs} sentInvites={sentInvites} />
            </div>
          </div>
        );
      }}
    />
  );
};

export default InviteExtUsers;
